import React, { CSSProperties } from 'react';
import Typography from '@mui/material/Typography';
import classnames from 'classnames';
import Spacings from '~/modules/ui-kit/spacings';
import styles from './styles.module.css';

type TagProps = {
  left?: React.ReactNode;
  children: React.ReactNode;
  style?: CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  isInteractive?: boolean;
};

const Tag = (props: TagProps) => (
  <div
    className={classnames(styles.tag, {
      [styles.interactive]: props.isInteractive,
    })}
    style={props.style}
    // remove onclick logic after route assignment refactoring
    {...(props.isInteractive
      ? {
          onClick: props.onClick,
          role: 'button',
          tabIndex: 0,
        }
      : {})}
  >
    <Spacings.Inline scale="xs" alignItems="center">
      {props.left}
      <Typography
        variant="caption"
        sx={{
          color: 'inherit',
        }}
      >
        {props.children}
      </Typography>
    </Spacings.Inline>
  </div>
);

export default Tag;
